import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { CredentialService } from "../credential.service";

@Injectable()
export class LoginGuard implements CanActivate {
  constructor(
    private router: Router,
    private http: HttpClient,
    private userService: CredentialService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const token = this.userService.getToken();
    const user = this.userService.getUser();
    if (user && token) {
      this.router.navigate(["dashboard"]);
      return true;
    }
    return true;
  }
}
